import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Calculator } from '@ratehub/base-ui';

import CALCULATOR_WIDTHS from '../definitions/CalculatorWidths';
import CompoundInterestCalcInputStep from './CompoundInterestCalcInputStep';


function CompoundInterestCalculator({ calculatorTitle, messageBannerProps, ...otherProps }) {
    return (
        <StyledCalculator
            title={calculatorTitle || (
                <FormattedMessage
                    id="calculators.CompoundInterestCalculator.calculatorTitle"
                    defaultMessage="Ratehub.ca’s compound interest calculator"
                />
            )}
            {...otherProps}
        >
            <CompoundInterestCalcInputStep
                messageBannerProps={messageBannerProps}
            />
        </StyledCalculator>
    );
}

CompoundInterestCalculator.propTypes = {
    calculatorTitle: PropTypes.string,
    messageBannerProps: PropTypes.shape({
        title: PropTypes.string,
        message: PropTypes.string,
        href: PropTypes.string,
        ctaMessage: PropTypes.string,
    }),
};


const StyledCalculator = styled(Calculator)`
    max-width: ${CALCULATOR_WIDTHS.SMALL};
`;

export default observer(CompoundInterestCalculator);
